import isEmpty from 'lodash/isEmpty';

const utils = {
  isMobile: function () {
    var isMobile = false;
    if (/Android|webOS|iPhone|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      isMobile = true;
    }
    return isMobile; // changd this
  },
  isPortable: function () {
    return false;
  },
  animationFrameShim: function () {
    window.requestAnimFrame = (function () {
      return (
        window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        function (callback) {
          window.setTimeout(callback, 1000 / 60);
        }
      );
    })();
  },
  getUnifiedLoginURL: (unifiedUrl, queryParameters = []) => {
    const url = decodeURIComponent(unifiedUrl);
    if (isEmpty(url)) {
      return unifiedUrl;
    }
    const urlParts = url.split('returnUri=');
    if (urlParts.length < 2) {
      return unifiedUrl;
    }
    let returnUri = urlParts[1];
    queryParameters.forEach(({ key, value }) => {
      returnUri = utils.addQuery(returnUri, key, value.toString());
    });
    return `${urlParts[0]}returnUri=${encodeURIComponent(returnUri)}`;
  },
  addQuery: (url, key, value) => {
    try {
      const newURL = new URL(url);
      const search = new URLSearchParams(newURL.search);
      search.set(key, value);
      newURL.search = search;
      return newURL.toString();
    } catch (e) {
      return url;
    }
  },
};

export default utils;
